var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-wrapper"},[_vm._t("default"),_vm._v(" "),_c('svg',{staticClass:"t-icon chevron-down svg-pointer",attrs:{"height":"22","width":"22"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }